"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.28,11.24v-.86A.29.29,0,0,0,10,10.1H7.68a.29.29,0,0,0-.29.29h0v.86Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.88,15.8a1.37,1.37,0,0,0-.5-.35,1.71,1.71,0,0,0-.66-.12h-1v3.52h1a1.7,1.7,0,0,0,.66-.12,1.37,1.37,0,0,0,.5-.35,1.53,1.53,0,0,0,.32-.55,2.56,2.56,0,0,0,0-1.48A1.53,1.53,0,0,0,13.88,15.8Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.47,8.94H12.29a1.44,1.44,0,0,0-1.44,1.44h0v1.44H7.11a.29.29,0,0,0-.29.29h0v9.21a.86.86,0,0,0,.86.86H18a.86.86,0,0,0,.86-.86V10.38a1.44,1.44,0,0,0-1.43-1.45ZM15.08,18.1a2.27,2.27,0,0,1-1.32,1.33,2.82,2.82,0,0,1-1.06.18H10.83v-5h1.9a2.8,2.8,0,0,1,1.06.18,2.33,2.33,0,0,1,.8.51,2.3,2.3,0,0,1,.51.79,2.87,2.87,0,0,1,0,2Zm1.81-6.29h-4a.86.86,0,0,1,0-1.72h4a.86.86,0,1,1,0,1.72Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.6",
    y: "2.38",
    width: "2.3",
    height: "5.18",
    rx: "0.29",
    ry: "0.29",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,3a10.64,10.64,0,0,1-1.51-.43c-3.19-1.06-3.19-1.06-6.23.52-.78.41-1.74.94-3,1.58a.29.29,0,0,0-.13.39l.05.07a1.87,1.87,0,0,0,2,.64l3.36-1.23,1.53.37-.29.21c-1,.72-2,1.48-1.66,2.13a.65.65,0,0,0,.6.43,5.4,5.4,0,0,0,1.67-.57l1.48-.64L16,7.07Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;